export const fixupAllCarriersWithSvgsReferenceData = (allTheCarriers) => {
  return allTheCarriers.map((carrier) => {
    return {
      carrierId: carrier.carrierId.toString(),
      confirmations: carrier.confirmations,
      active: carrier.active,
    };
  });
};

export const getCarriersFromIds = (carrierIds, fixedUpAllCarriers) => {
  return carrierIds
    .map((carrierId) => {
      return fixedUpAllCarriers.find((element) => element.carrierId === carrierId);
    })
    .filter((carrier) => !!carrier);
};
